import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@UntilDestroy()
@Directive({
  selector: '[appDebounceClick]',
  standalone: true,
})
export class DebounceClickDirective implements OnInit {
  @Input() debounceTime = 1000;
  @Output() debounceClick = new EventEmitter();
  private readonly clicks = new Subject();

  ngOnInit(): void {
    this.clicks
      .pipe(untilDestroyed(this), throttleTime(this.debounceTime))
      .subscribe(e => {
        this.debounceClick.emit(e);
      });
  }
  @HostListener('click', ['$event'])
  clickEvent(event): void {
    event.preventDefault();
    event.stopPropagation();

    this.clicks.next(event);
  }
}
